const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 473.68 473.68",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 236.85,
    cy: 236.85,
    r: 236.83,
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.14 157.877H314.219c6.335 50.593 6.376 106.339.12 156.995h146.116a236.43 236.43 0 0 0 13.219-78.03 236.24 236.24 0 0 0-13.534-78.965z",
    style: {},
    fill: "#efecec",
    "data-original": "#efecec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.219 157.877h145.922a6.687 6.687 0 0 0-.075-.206C429.753 72.204 351.786 9.323 258.105.976c36.253 19.872 46.839 82.832 56.114 156.901z",
    style: {},
    fill: "#e63026",
    "data-original": "#e63026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.109 472.701c93.848-8.362 171.927-71.46 202.12-157.156.079-.228.146-.452.228-.673h-146.12c-9.194 74.47-19.827 137.874-56.228 157.829z",
    style: {},
    fill: "#2b479d",
    "data-original": "#2b479d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.001 236.842a236.43 236.43 0 0 0 13.219 78.03h313.313c6.256-50.66 6.215-106.402-.12-156.995H13.534C4.798 182.577.001 209.143.001 236.842z",
    style: {},
    fill: "#efefef",
    "data-original": "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.604 157.672a5.85 5.85 0 0 0-.075.206h312.883C317.138 83.808 294.356 20.849 258.109.977 251.098.355 244.007 0 236.835 0 133.807 0 46.185 65.805 13.604 157.672z",
    style: {},
    fill: "#e73b36",
    "data-original": "#e73b36",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.533 314.872H13.22c.079.221.15.445.228.673C45.9 407.647 133.637 473.68 236.835 473.68c7.173 0 14.263-.352 21.274-.98 36.401-19.954 59.228-83.358 68.424-157.828z",
    style: {},
    fill: "#3757a6",
    "data-original": "#3757a6",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag1);
export default __webpack_public_path__ + "static/media/flag1.766b7a4d7ebdefff475776570aeb60f3.svg";
export { ForwardRef as ReactComponent };